"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ast_1 = require("../util/ast");
const rules_1 = require("../rules");
exports.assignment = ({ ast, execObject }) => {
    const obj = ast.children.rules[0];
    const from = execObject.interpreter({ ast: obj.children.head[0], execObject });
    if (obj.children.tail) {
        const toObject = obj.children.tail[0];
        if (toObject.name === rules_1.Rules.ArrayElement) {
            const name = toObject.children.IdentifierSuffix[0].image.slice(0, -1);
            const index = ast_1.getIndex({ ast: toObject.children.rules[0], execObject });
            execObject.manager.variable.assignment(name, from, index);
        }
        else {
            execObject.manager.variable.assignment(toObject.image, from);
        }
        return toObject;
    }
    return;
};
